import { render, staticRenderFns } from "./AssineForm.vue?vue&type=template&id=44e57b90&scoped=true&"
import script from "./AssineForm.vue?vue&type=script&lang=js&"
export * from "./AssineForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e57b90",
  null
  
)

export default component.exports